<template>
  <Drawer :title="title" :size="size" :value="visible" @input="onInput">
    <a
      :href="src"
      :data-text="$t('common.openExternal')"
      target="_blank"
      class="c-drawer__float-button"
    >
      <i class="icofont-external-link"></i>
    </a>
    <iframe
      v-if="visible && src"
      :src="src"
      style="overflow: hidden; height: 90vh; width: 100%"
      frameborder="0"
    ></iframe>
  </Drawer>
</template>

<script>
import { mapGetters } from "vuex";
import Drawer from "@/components/Base/Drawer.vue";

export default {
  components: { Drawer },
  data() {
    return {
      closingFromNavigation: false,
      removeNavigationGuard: null,
    };
  },
  created() {
    this.removeNavigationGuard = this.$router.beforeEach((to, from, next) => {
      if (!this.visible || !from.query.iframe) {
        next();
        return;
      }

      const baseRoute = this.withoutIframe(from);
      const targetRoute = this.withoutIframe(to);
      const samePage =
        this.$router.resolve(baseRoute).route.fullPath ===
        this.$router.resolve(targetRoute).route.fullPath;

      if (samePage && to.query.iframe) {
        next();
        return;
      }

      // Consume navigation while the drawer is open, preserving the list filters.
      this.closingFromNavigation = true;
      this.$store.dispatch("SET_RESET_IFRAME_DRAWER");
      next(samePage ? undefined : { ...baseRoute, replace: true });
    });
  },
  beforeDestroy() {
    if (this.removeNavigationGuard) this.removeNavigationGuard();
  },
  computed: {
    ...mapGetters(["getIframeDrawer"]),
    visible() {
      return this.getIframeDrawer?.status || false;
    },
    title() {
      return this.getIframeDrawer?.title || "";
    },
    src() {
      return this.getIframeDrawer?.src || "";
    },
    size() {
      return this.getIframeDrawer?.size || "lg";
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.closingFromNavigation = false;
        if (this.$route.query.iframe === this.src) return;
        this.$router.push({
          path: this.$route.path,
          hash: this.$route.hash,
          query: {
            ...this.$route.query,
            iframe: this.src,
          },
        });
      } else if (!this.closingFromNavigation && this.$route.query.iframe) {
        this.$router.replace(this.withoutIframe(this.$route));
      }
    },
    $route(to) {
      if (this.visible && !to.query.iframe) {
        this.$store.dispatch("SET_RESET_IFRAME_DRAWER");
      }
    },
  },
  methods: {
    withoutIframe(route) {
      const query = { ...route.query };
      delete query.iframe;
      return { path: route.path, hash: route.hash, query };
    },
    onInput(value) {
      if (!value) {
        this.$store.dispatch("SET_RESET_IFRAME_DRAWER");
      }
    },
  },
};
</script>

<style></style>
